module.exports = __webpack_public_path__ + "img/icon-yoboy.ba6a417f.png";